<!-- eslint-disable vue/no-unused-vars -->
<template>
    <b-card no-body>
        <b-card-header class="border-0">
			<b-row ></b-row>
		</b-card-header>


        <b-col cols="12">
			<b-row class="d-flex align-items-center justify-content-md-between">
				<b-col cols="12" md="8" class="d-md-flex">
					<base-input
						label="Search"
						v-model="searchQuery"
						v-on:input="debouncedHandler"
						placeholder="Search"
					>
					</base-input>				
				</b-col>
				<b-col cols="12" md="4">
					<b-row class="d-flex align-items-center justify-content-md-end">
                        <b-col cols="auto" class="mb-3 float-right">
                            Pending approval only
                            <el-switch
                                v-model="pending_only"
                                active-color="#0BC196"
                            ></el-switch>
                        </b-col>
						<b-col cols="auto" class="mb-3">
							<el-button class="float-right px-3 py-2 mb-2 mb-md-0" 
                                type="gray" plain
                            >
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"/></svg>
								Filters
							</el-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>

            <b-row class="d-flex align-items-center mb-3">
                <b-col cols="12" md="8" class="d-flex">
                    <div
                        v-for="(status, index) in statusList"
                        :key="index"
                        :style="{ 
                            borderColor: status.active ? itemBorderColor(status) : 'grey', 
                            borderWidth: status.active  ? '2px' : '1px', 
                            borderStyle: 'solid',
                            color: status.active ? itemBorderColor(status) : 'black'
                        }"
                        @click.prevent="setActive(status)"
                        class="rounded text-center cursor-pointer p-3 mx-2"
                    >
                        <span class="font-weight-500">{{ status.name }}</span><br>
                        <span class="font-weight-600">{{ status.value }}</span>
                    </div>
                </b-col>
            </b-row>
		</b-col>

        <div class="table-listings">
            <el-table
				ref="multipleTable"
				:data="tableData"
				style="width: 100%"
				@selection-change="selectionChange"
				class="mt-4"
				v-loading="isTableLoading"
			>
                <el-table-column
					type="selection"
					width="45"
				></el-table-column>

				<el-table-column width="70" class-name="icons-chat">
						<template slot-scope="scope">
							<MessagingBoxButton :type="'invinity_customer'" :profile="scope.row" />
						</template>
				</el-table-column>

                <el-table-column
					label="Investor/ ID"
					min-width="150"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <div>
                            <div class="d-flex align-items-center">
                                <el-tooltip effect="dark" placement="right">
                                    <div slot="content" class="d-flex align-items-center">
                                        {{ scope.row.investor_name }}
                                        <svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer ml-2" @click.prevent="copyToClipboard(scope.row.investor_name)" width="14" height="18" viewBox="0 0 448 512"><path fill="currentColor" d="M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"/></svg>
                                    </div>
                                    <router-link :to="'/funds_management/investors_profile/detail?active=overview'">
                                        <p class="top-line text-primary">{{ scope.row.investor_name }}</p>
                                    </router-link>
                                </el-tooltip>
                            </div>
                            <div class="d-flex align-items-center">
                                <p class="bottom-line">{{ scope.row.investor_id }}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
					label="Status"
					min-width="150"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <div class="d-flex">
                            <el-dropdown trigger="click" v-model="scope.row.status" style="cursor: pointer;">
                                <p class="el-dropdown-link top-line">
                                    <span class="d-inline-block text-truncate" 
                                        style="max-width: 150px; overflow: unset;"
                                        :class="getStatusColor(scope.row.status)"
                                    >{{ scope.row.status }}</span>
                                    <i class="el-icon-caret-bottom el-icon--right"></i>
                                </p>
                                <el-dropdown-menu slot="dropdown">
                                    <div style="max-height: 300px;overflow-y: auto;">
                                        <el-dropdown-item v-for="(status, index) in statusList" :key="index" >{{ status.name }}</el-dropdown-item>
                                    </div>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
					label="No. of Fund"
					min-width="100"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope" >
                        <svg id="cases-svg" width="50" height="50">
                            <circle cx="25" cy="25" r="18" stroke="#13663E" stroke-width="2" fill="#EEFCF5" />
                            <text x="25" y="30" text-anchor="middle" fill="#13663E" class="cases-text">0</text>
                        </svg>
                    </template>
                </el-table-column>

                <el-table-column
					label="Approval Status/ Request Type"
					min-width="150"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <span class="text-white rounded-pill bg-warning px-3 mr-2">{{ scope.row.approval_sts }}</span>
                        <p class="bottom-line">{{ scope.row.request_type }}</p>
                    </template>
                </el-table-column>

                <el-table-column
					label="Total Contribution Amt./ Total UTD Interest Rel."
					min-width="150"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">RM {{ scope.row.total_cont_amt | moneyFormatter }}</p>
                        <p class="bottom-line">RM {{ scope.row.total_utd_interest_rel | moneyFormatter }}</p>
                    </template>
                </el-table-column>

                <el-table-column
					label="Total UTD Profit (%)/ Total UTD Loss"
					min-width="150"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <span class="top-line text-success">RM {{ scope.row.total_utd_profit | moneyFormatter }} </span>
                        <span class="top-line text-success">({{ scope.row.total_utd_profit_percent }})</span>
                        <p class="bottom-line">RM {{ scope.row.total_utd_loss | moneyFormatter }}</p>
                    </template>
                </el-table-column>

                <el-table-column
					label="Profit (p.a)/ Release Term"
					min-width="150"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">{{ scope.row.profit_percent }}</p>
                        <p class="bottom-line">{{ scope.row.release_term }}</p>
                    </template>
                </el-table-column>

                <el-table-column
					label="Next Withdrawal/ Latest Withdrawal"
					min-width="150"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">{{ scope.row.next_withdrawal }}</p>
                        <p class="bottom-line">{{ scope.row.latest_withdrawal }}</p>
                    </template>
                </el-table-column>

                <el-table-column
					label="Referee"
					min-width="150"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">{{ scope.row.referee }}</p>
                    </template>
                </el-table-column>

                <el-table-column
					fixed="right"
					width="25"
					align="center"
					class-name="px-0"
				>
					<template>
						<el-dropdown trigger="click"  style="cursor: pointer">
							<p class="el-dropdown-link mb-0 top-line">
								<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
							</p>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item> 
									<!-- Eye Icon -->
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="#13663E" d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>
									View Change Log
								</el-dropdown-item>
								<el-dropdown-item>
									<span class="text-danger">
										<!-- Trash-Can Icon -->
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="#DF3030" d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"/></svg>
										Delete
									</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
            </el-table>
        </div>
    </b-card>
</template>
<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button, Switch } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce } from '@/assets/js/httpImports.js'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'

export default {
    mixins: [clientPaginationMixin],
    components: {
        // eslint-disable-next-line vue/no-unused-components
        BasePagination,
				MessagingBoxButton,
        [Select.name]: Select,
        [Option.name]: Option,
        [Tooltip.name]: Tooltip,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Switch.name]: Switch,
    },
    data() {
        return {
            propsToSearch:[''],
            pending_only: false,
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            isTableLoading: false,
            isFixed: true,
            tableData: [
                {
                    investor_name: 'Edward Jo',
                    investor_id: 3619,
                    status: 'In-Progressive',
                    no_of_fund: 2,
                    approval_sts: 'Pending',
                    request_type: 'Early Terminate',
                    total_cont_amt: 80000,
                    total_utd_interest_rel: 1800,
                    total_utd_profit: 9600,
                    total_utd_profit_percent: '30%',
                    total_utd_loss: 2400,
                    profit_percent: '15%',
                    release_term: '24-36 months',
                    next_withdrawal: '27 Jul 2024',
                    latest_withdrawal: '28 Jun 2024',
                    referee: 'Karen Chin'
                }
            ],
            statusList: [
                { name: 'In-Progressive', value: 2, active: false },
                { name: 'Withdrawer', value: 1, active: false },
                { name: 'Completed', value: 0, active: false },
            ],
        }
    },
    mounted(){
        this.debouncedHandler = debounce(() => {
        // this.searchFinancialProposalList();
        }, 500);
    },
    methods: {
        paginationChanged(page) {
            this.pagination.currentPage = page
        },
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        copyToClipboard(value) {
            const tempInput = document.createElement('input');
            tempInput.value = value;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);

            _gNotif.notifySuccess(value+'<br>Copied to Clipboard.')
        },
        getStatusColor(status) {
            switch (status) {
              case 'In-Progressive':
                  return 'text-warning'; // Change to green color class
                  break;
              case 'Withdrawer':
                  return 'text-danger'; // Change to yellow color class
                  break;
              case 'Completed':
                  return 'text-success'; // Change to red color class
                  break;
              default:
                  return 'text-dark'; // Change to dark color class
                  break;
            }
        },
        itemBorderColor(item) {
            // Define the mapping of names to border colors
            const colorMap = {
                All: '#13663E',
                'In-Progressive': '#DC9A0F',
                Withdrawer: '#DF3030',
                Completed: '#0BC196'
            };

            // Return the corresponding border color for the current item
            return colorMap[item.name] || 'grey';
        },
        setActive(clickedStatus) {
            this.statusList.forEach(status => {
                status.active = status === clickedStatus;
            });

            if (clickedStatus.active) {
                this.activeBorder = this.itemBorderColor(clickedStatus);
            } else {
                this.activeBorder = '';
            }
        },
    }
}
</script>